import { fromJS } from 'immutable';

import {
  FETCH_EMPLOYEES,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILED,
  FETCH_EMPLOYEE_SUCCESS,
  FETCH_EMPLOYEE_FAILED,
  SET_EMPLOYEE,
  SET_IMAGE,
  SET_IMAGE_DOWNLOAD_URL,
  ADD_TAG,
  REMOVE_TAG,
  // ADD_ROLE,
  // REMOVE_ROLE,
  ADD_PERMISSION,
  REMOVE_PERMISSION,
} from '../actions/employees';
import { updateOrAdd, remove } from './helper';

import { saveEmployeeRoutine, removeEmployeeRoutine } from '../routines';

const initialState = fromJS({
  employees: [],
  employee: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_EMPLOYEES:
      return state.set('loading', true);
    case FETCH_EMPLOYEES_SUCCESS:
      return state.set('employees', fromJS(action.employees)).set('loading', false);
    case FETCH_EMPLOYEES_FAILED:
      return state.set('error', action.error).set('loading', false);
    case FETCH_EMPLOYEE_SUCCESS:
      return state.set('employee', fromJS(action.employee)).set('loading', false);
    case FETCH_EMPLOYEE_FAILED:
      return state.set('error', action.error).set('loading', false);
    case SET_EMPLOYEE:
      return state.set('employee', fromJS(action.employee));
    case SET_IMAGE:
      console.log('SET_LOGOredu', action.image);
      return state.setIn(['employee', 'image'], action.image);
    case SET_IMAGE_DOWNLOAD_URL:
      return state.setIn(['employee', 'imageUrl'], action.imageUrl);
    case ADD_TAG:
      return state.updateIn(['employee', 'tags'], updateOrAdd(action.tag, (obj) => obj));
    case REMOVE_TAG:
      return state.updateIn(['employee', 'tags'], remove(action.tag, (obj) => obj));
    case ADD_PERMISSION:
      return state.setIn(['employee', 'permissions', action.permission.id], true);
    case REMOVE_PERMISSION:
      return state.deleteIn(['employee', 'permissions', action.permission]);
    // case ADD_ROLE:
    //   return state.updateIn(['employee', 'roles'], updateOrAdd(fromJS(action.role)));
    // case REMOVE_ROLE:
    //   return state.updateIn(['employee', 'roles'], remove(fromJS(action.role)));
    case saveEmployeeRoutine.TRIGGER:
      return state;
    case saveEmployeeRoutine.SUCCESS:
      const employee = fromJS(action.payload.employee);
      console.log('employee', employee);
      return state.set('employee', employee).set('saving', false)
        .updateIn(['employees'], updateOrAdd(employee));
    case saveEmployeeRoutine.FAILURE:
      return state.set('error', action.error).set('saving', false);
    case saveEmployeeRoutine.FULFILL:
      return state;
    case removeEmployeeRoutine.SUCCESS:
      return state.updateIn(['employees'], remove(fromJS(action.payload.employee)));
    case removeEmployeeRoutine.FAILURE:
      return state.set('error', action.error);
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/employees.js